/* eslint-disable n/handle-callback-err */
import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

const ZApiResponse = z.string()

export type ApiResponse = z.infer<typeof ZApiResponse>

export async function getAssetImageByName (
  assetId: string,
  name: string,
  onSuccess: (images: string, httpStatus: number) => any,
  onFailure: (httpStatus: number) => any
): Promise<void> {
  const url = `/fileuploadservice/api/v1/udp/asset-profile/download-meter-image?assetId=${assetId}&imageName=${name}`

  interceptedAxios
    .get(url)
    .then((response) => {
      const parseResponse = ZApiResponse.safeParse(response.data)
      if (parseResponse.success) {
        if (parseResponse.data !== undefined && parseResponse.data.length > 0) {
          onSuccess(parseResponse.data, response.status)
        } else {
          onFailure(response.status)
        }
      } else {
        onFailure(response.status)
      }
    })
    .catch((error) => {
      if (error.response?.status !== undefined) {
        onFailure(error.response.status)
      } else {
        onFailure(500)
      }
    })
}
